// Translations for Arabic, English, and German
export const translations = {
  ar: {
    // Login
    login: {
      title: 'لوحة التحكم',
      subtitle: 'نظام إرسال البريد التلقائي',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      submit: 'تسجيل الدخول',
      loading: 'جاري تسجيل الدخول...',
      error: 'بريد إلكتروني أو كلمة مرور خاطئة',
      connectionError: 'حدث خطأ في الاتصال بالسيرفر',
      version: 'نظام أتمتة البريد الإلكتروني v4.0'
    },
    // Dashboard
    dashboard: {
      title: 'نظام أتمتة البريد الإلكتروني',
      version: 'الإصدار 4.0',
      logout: 'تسجيل الخروج',
      language: 'اللغة'
    },
    // Stats
    stats: {
      totalClients: 'إجمالي العملاء',
      subscribed: 'المشتركين',
      replied: 'الردود',
      pendingEmails: 'الرسائل المعلقة',
      sentEmails: 'الرسائل المرسلة'
    },
    // Tabs
    tabs: {
      settings: 'إعدادات البريد',
      multiLangAds: 'اعلانات متعددة اللغات',
      adTemplates: 'قوالب الإعلانات',
      keywords: 'الكلمات المفتاحية',
      leads: 'العملاء',
      scheduled: 'المجدولة',
      replies: 'الردود',
      broadcast: 'الإرسال الجماعي',
      whatsapp: 'واتساب'
    },
    // System Status
    system: {
      title: 'حالة النظام',
      running: 'النظام يعمل - مراقبة البريد',
      stopped: 'النظام متوقف',
      start: 'تشغيل النظام',
      stop: 'إيقاف النظام'
    },
    // Settings
    settings: {
      senderEmail: 'بريد الإرسال (SMTP)',
      receiverEmail: 'بريد الاستقبال (IMAP)',
      senderName: 'اسم المرسل',
      emailAddress: 'عنوان البريد',
      appPassword: 'كلمة مرور التطبيق',
      host: 'الخادم',
      port: 'المنفذ',
      welcomeEmail: 'رسالة الترحيب (تلقائي)',
      welcomeEmailDesc: 'تُرسل هذه الرسالة تلقائياً لكل عميل جديد عند حفظه',
      enable: 'تفعيل',
      subject: 'الموضوع',
      body: 'المحتوى',
      saveSettings: 'حفظ الإعدادات',
      saving: 'جاري الحفظ...'
    },
    // Ad Templates
    adTemplates: {
      title: 'قوالب الإعلانات اليومية',
      campaignDuration: 'مدة الحملة',
      campaignDurationDesc: 'حدد عدد أيام إرسال الرسائل للعملاء الجدد (رسالة واحدة يومياً فقط)',
      duration: 'المدة:',
      days: 'يوم',
      week: 'أسبوع',
      weeks: 'أسابيع',
      month: 'شهر',
      months: 'أشهر',
      templatesRepeat: 'القوالب تتكرر إذا كانت الحملة أطول من 7 أيام',
      day: 'اليوم',
      active: 'مفعل',
      saveTemplates: 'حفظ القوالب',
      firstAdNote: 'ملاحظة: أول إعلان يُرسل تلقائياً فور إضافة العميل',
      variablesHint: 'المتغيرات المتاحة:',
      variableName: 'اسم العميل',
      variablePhone: 'هاتف العميل',
      variableEmail: 'بريد العميل',
      variablesExample: 'مثال: مرحباً {name}، لدينا عرض خاص لك!'
    },
    // Keywords
    keywords: {
      title: 'الكلمات المفتاحية للرد التلقائي',
      subtitle: 'الرد يُرسل تلقائياً وفورياً عند اكتشاف أي كلمة مفتاحية',
      keyword: 'الكلمة المفتاحية',
      replySubject: 'عنوان الرد',
      replyTemplate: 'قالب الرد',
      add: 'إضافة',
      noKeywords: 'لا توجد كلمات مفتاحية',
      matches: 'تطابقات',
      emailsSent: 'رسائل مرسلة',
      autoReplyNote: 'الرد التلقائي مفعل - يُرسل فوراً عند اكتشاف الكلمة'
    },
    // Leads
    leads: {
      title: 'العملاء',
      search: 'بحث...',
      addClient: 'إضافة عميل',
      name: 'الاسم',
      email: 'البريد',
      phone: 'الهاتف',
      status: 'الحالة',
      actions: 'الإجراءات',
      subscribed: 'مشترك',
      replied: 'رد',
      unsubscribed: 'غير مشترك',
      extend: 'تمديد',
      delete: 'حذف',
      noClients: 'لا يوجد عملاء'
    },
    // Add Lead Modal
    addLead: {
      title: 'إضافة عميل جديد',
      pasteMessage: 'الصق محتوى الرسالة هنا (Umzugsdetails)',
      pasteMessagePlaceholder: 'الصق محتوى رسالة الطلب هنا...',
      extractedData: 'البيانات المستخرجة (يمكنك التعديل):',
      clientName: 'الاسم',
      clientEmail: 'البريد الإلكتروني *',
      clientPhone: 'الهاتف',
      addNote: 'عند إضافة العميل:',
      addNoteWelcome: '1. ستُرسل رسالة الترحيب (إذا كانت مفعلة)',
      addNoteFirstAd: '2. ستُرسل أول رسالة إعلانية فوراً',
      addNoteSchedule: '3. ستُجدول باقي الرسائل الإعلانية',
      addButton: 'إضافة العميل وإرسال',
      adding: 'جاري الإضافة...',
      cancel: 'إلغاء'
    },
    // Scheduled Emails
    scheduled: {
      title: 'الرسائل المجدولة',
      client: 'العميل',
      subject: 'الموضوع',
      scheduledFor: 'موعد الإرسال',
      status: 'الحالة',
      actions: 'الإجراءات',
      sendNow: 'إرسال الآن',
      cancel: 'إلغاء',
      pending: 'معلق',
      sent: 'مرسل',
      failed: 'فشل',
      cancelled: 'ملغي',
      noScheduled: 'لا توجد رسائل مجدولة'
    },
    // Unknown Replies
    replies: {
      title: 'الردود غير المعروفة',
      from: 'من',
      message: 'الرسالة',
      date: 'التاريخ',
      markRead: 'تحديد كمقروء',
      resolve: 'حل',
      noReplies: 'لا توجد ردود'
    },
    // Broadcast
    broadcast: {
      title: 'الإرسال الجماعي',
      description: 'إرسال رسالة لجميع العملاء المشتركين',
      subject: 'الموضوع',
      body: 'المحتوى',
      attachment: 'مرفق (PDF، صورة، فيديو)',
      send: 'إرسال للجميع',
      sending: 'جاري الإرسال...',
      confirmTitle: 'تأكيد الإرسال',
      confirmMessage: 'هل تريد إرسال رسالة جماعية إلى {count} عميل؟'
    },
    // Messages
    messages: {
      success: 'تم بنجاح',
      error: 'حدث خطأ',
      saved: 'تم الحفظ',
      deleted: 'تم الحذف',
      sent: 'تم الإرسال',
      cancelled: 'تم الإلغاء',
      confirmDelete: 'هل أنت متأكد من الحذف؟',
      fillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
      emailRequired: 'البريد الإلكتروني مطلوب',
      clientAdded: 'تم إضافة العميل وإرسال أول إعلان بنجاح',
      keywordAdded: 'تمت إضافة الكلمة المفتاحية',
      keywordDeleted: 'تم حذف الكلمة المفتاحية',
      autoReplyEnabled: 'الرد التلقائي مفعل'
    },
    // Common
    common: {
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      search: 'بحث',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      previous: 'السابق',
      next: 'التالي',
      page: 'صفحة',
      of: 'من',
      yes: 'نعم',
      no: 'لا',
      close: 'إغلاق'
    },
    // WhatsApp
    whatsapp: {
      title: 'واتساب',
      settings: 'إعدادات الواتساب',
      contacts: 'جهات الاتصال',
      keywords: 'الكلمات المفتاحية',
      bulkMessages: 'الرسائل الجماعية',
      messages: 'سجل الرسائل',
      // Settings
      apiType: 'نوع API',
      ultraMsgSettings: 'إعدادات UltraMsg',
      instanceId: 'معرف Instance',
      token: 'التوكن',
      metaSettings: 'إعدادات Meta Cloud API',
      accessToken: 'Access Token',
      phoneNumberId: 'Phone Number ID',
      businessAccountId: 'Business Account ID',
      wahaSettings: 'إعدادات WAHA',
      apiUrl: 'رابط API',
      sessionName: 'اسم الجلسة',
      apiKey: 'مفتاح API',
      twilioSettings: 'إعدادات Twilio',
      accountSid: 'Account SID',
      authToken: 'Auth Token',
      whatsappNumber: 'رقم واتساب',
      autoSendFirstAd: 'إرسال أول إعلان تلقائياً',
      testConnection: 'اختبار الاتصال',
      testPhone: 'رقم الاختبار',
      // Delay settings
      delaySettings: 'إعدادات التأخير (لتجنب الحظر)',
      minDelay: 'الحد الأدنى للتأخير (ثواني)',
      maxDelay: 'الحد الأقصى للتأخير (ثواني)',
      pauseAfter: 'توقف بعد (رسالة)',
      pauseDuration: 'مدة التوقف (ثواني)',
      // Ad messages
      adMessages: 'رسائل الإعلانات (8 رسائل)',
      adMessage: 'رسالة الإعلان',
      adDay: 'يوم الإرسال',
      attachment: 'مرفق',
      attachmentType: 'نوع المرفق',
      uploadFile: 'رفع ملف',
      noAttachment: 'بدون مرفق',
      image: 'صورة',
      video: 'فيديو',
      document: 'مستند',
      // Contacts
      addContact: 'إضافة جهة اتصال',
      importCSV: 'استيراد CSV',
      exportContacts: 'تصدير جهات الاتصال',
      phone: 'رقم الهاتف',
      name: 'الاسم',
      email: 'البريد',
      source: 'المصدر',
      status: 'الحالة',
      adsSent: 'الإعلانات المرسلة',
      hasReplied: 'رد',
      active: 'نشط',
      blocked: 'محظور',
      invalid: 'غير صالح',
      manual: 'يدوي',
      fromEmail: 'من البريد',
      csvImport: 'استيراد CSV',
      // Keywords
      keywordTitle: 'الكلمات المفتاحية للواتساب',
      keywordSubtitle: 'الرد يُرسل تلقائياً عند اكتشاف الكلمة',
      keyword: 'الكلمة',
      response: 'الرد',
      matchType: 'نوع المطابقة',
      contains: 'يحتوي',
      exact: 'مطابق تماماً',
      startsWith: 'يبدأ بـ',
      priority: 'الأولوية',
      timesTriggered: 'مرات التفعيل',
      // Bulk messages
      bulkTitle: 'الرسائل الجماعية',
      createBulkJob: 'إنشاء رسالة جماعية',
      jobName: 'اسم المهمة',
      message: 'الرسالة',
      selectContacts: 'اختر جهات الاتصال',
      allContacts: 'جميع جهات الاتصال',
      selectSpecific: 'اختيار محدد',
      pasteNumbers: 'لصق أرقام',
      pasteNumbersPlaceholder: 'ألصق الأرقام مفصولة بفواصل...',
      startJob: 'بدء الإرسال',
      pauseJob: 'إيقاف مؤقت',
      resumeJob: 'استئناف',
      cancelJob: 'إلغاء',
      jobStatus: 'الحالة',
      progress: 'التقدم',
      sent: 'مرسل',
      failed: 'فشل',
      pending: 'معلق',
      running: 'قيد التشغيل',
      paused: 'متوقف مؤقتاً',
      completed: 'مكتمل',
      cancelled: 'ملغي',
      // Messages
      sendMessage: 'إرسال رسالة',
      incoming: 'وارد',
      outgoing: 'صادر',
      messageHistory: 'سجل الرسائل',
      // Stats
      totalContacts: 'إجمالي جهات الاتصال',
      activeContacts: 'جهات الاتصال النشطة',
      contactsWithReplies: 'الذين ردوا',
      totalMessagesSent: 'الرسائل المرسلة',
      totalMessagesReceived: 'الرسائل المستلمة',
      totalAdsSent: 'الإعلانات المرسلة',
      totalKeywordReplies: 'ردود الكلمات المفتاحية',
      activeKeywords: 'الكلمات المفتاحية النشطة',
      runningJobs: 'المهام قيد التشغيل',
      syncFromEmail: 'مزامنة من عملاء البريد',
      webhookSetup: 'اعداد Webhook مطلوب',
      webhookInfo: 'لاستقبال رسائل واتساب الواردة والرد التلقائي بالكلمات المفتاحية، قم بتكوين رابط Webhook هذا في اعدادات مزود WhatsApp API:',
      webhookInstructions: 'انسخ هذا الرابط والصقه في اعدادات webhook الخاصة بـ UltraMsg/Meta/WAHA.',
      testKeyword: 'اختبار مطابقة الكلمات المفتاحية',
      testPhone: 'رقم الهاتف (مثال: +96171910201)',
      testMessage: 'رسالة اختبار تحتوي على كلمة مفتاحية',
      testButton: 'اختبار',
      bulkVariablesNote: 'استخدم هذه المتغيرات لتخصيص كل رسالة بمعلومات العميل'
    }
  },

  en: {
    // Login
    login: {
      title: 'Control Panel',
      subtitle: 'Email Automation System',
      email: 'Email Address',
      password: 'Password',
      submit: 'Sign In',
      loading: 'Signing in...',
      error: 'Invalid email or password',
      connectionError: 'Server connection error',
      version: 'Email Automation System v4.0'
    },
    // Dashboard
    dashboard: {
      title: 'Email Automation System',
      version: 'Version 4.0',
      logout: 'Logout',
      language: 'Language'
    },
    // Stats
    stats: {
      totalClients: 'Total Clients',
      subscribed: 'Subscribed',
      replied: 'Replied',
      pendingEmails: 'Pending Emails',
      sentEmails: 'Sent Emails'
    },
  // Tabs
  tabs: {
  settings: 'Email Settings',
  multiLangAds: 'Multi-Lang Ads',
  adTemplates: 'Ad Templates',
  keywords: 'Keywords',
  leads: 'Clients',
  scheduled: 'Scheduled',
  replies: 'Replies',
  broadcast: 'Broadcast',
  whatsapp: 'WhatsApp'
    },
    // System Status
    system: {
      title: 'System Status',
      running: 'System is running - Monitoring emails',
      stopped: 'System is stopped',
      start: 'Start System',
      stop: 'Stop System'
    },
    // Settings
    settings: {
      senderEmail: 'Sender Email (SMTP)',
      receiverEmail: 'Receiver Email (IMAP)',
      senderName: 'Sender Name',
      emailAddress: 'Email Address',
      appPassword: 'App Password',
      host: 'Host',
      port: 'Port',
      welcomeEmail: 'Welcome Email (Auto)',
      welcomeEmailDesc: 'This email is sent automatically to each new client when saved',
      enable: 'Enable',
      subject: 'Subject',
      body: 'Body',
      saveSettings: 'Save Settings',
      saving: 'Saving...'
    },
    // Ad Templates
    adTemplates: {
      title: 'Daily Ad Templates',
      campaignDuration: 'Campaign Duration',
      campaignDurationDesc: 'Set the number of days to send emails to new clients (one email per day only)',
      duration: 'Duration:',
      days: 'days',
      week: 'week',
      weeks: 'weeks',
      month: 'month',
      months: 'months',
      templatesRepeat: 'Templates repeat if campaign is longer than 7 days',
      day: 'Day',
      active: 'Active',
      saveTemplates: 'Save Templates',
      firstAdNote: 'Note: First ad is sent automatically immediately when client is added',
      variablesHint: 'Available Variables:',
      variableName: "Client's name",
      variablePhone: "Client's phone",
      variableEmail: "Client's email",
      variablesExample: 'Example: Hello {name}, we have a special offer for you!'
    },
    // Keywords
    keywords: {
      title: 'Auto-Reply Keywords',
      subtitle: 'Reply is sent automatically and immediately when any keyword is detected',
      keyword: 'Keyword',
      replySubject: 'Reply Subject',
      replyTemplate: 'Reply Template',
      add: 'Add',
      noKeywords: 'No keywords',
      matches: 'Matches',
      emailsSent: 'Emails Sent',
      autoReplyNote: 'Auto-reply enabled - sends immediately when keyword is detected'
    },
    // Leads
    leads: {
      title: 'Clients',
      search: 'Search...',
      addClient: 'Add Client',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      status: 'Status',
      actions: 'Actions',
      subscribed: 'Subscribed',
      replied: 'Replied',
      unsubscribed: 'Unsubscribed',
      extend: 'Extend',
      delete: 'Delete',
      noClients: 'No clients'
    },
    // Add Lead Modal
    addLead: {
      title: 'Add New Client',
      pasteMessage: 'Paste message content here (Umzugsdetails)',
      pasteMessagePlaceholder: 'Paste the request message content here...',
      extractedData: 'Extracted data (you can edit):',
      clientName: 'Name',
      clientEmail: 'Email *',
      clientPhone: 'Phone',
      addNote: 'When adding the client:',
      addNoteWelcome: '1. Welcome email will be sent (if enabled)',
      addNoteFirstAd: '2. First ad email will be sent immediately',
      addNoteSchedule: '3. Remaining ad emails will be scheduled',
      addButton: 'Add Client & Send',
      adding: 'Adding...',
      cancel: 'Cancel'
    },
    // Scheduled Emails
    scheduled: {
      title: 'Scheduled Emails',
      client: 'Client',
      subject: 'Subject',
      scheduledFor: 'Scheduled For',
      status: 'Status',
      actions: 'Actions',
      sendNow: 'Send Now',
      cancel: 'Cancel',
      pending: 'Pending',
      sent: 'Sent',
      failed: 'Failed',
      cancelled: 'Cancelled',
      noScheduled: 'No scheduled emails'
    },
    // Unknown Replies
    replies: {
      title: 'Unknown Replies',
      from: 'From',
      message: 'Message',
      date: 'Date',
      markRead: 'Mark as Read',
      resolve: 'Resolve',
      noReplies: 'No replies'
    },
    // Broadcast
    broadcast: {
      title: 'Broadcast',
      description: 'Send a message to all subscribed clients',
      subject: 'Subject',
      body: 'Body',
      attachment: 'Attachment (PDF, Image, Video)',
      send: 'Send to All',
      sending: 'Sending...',
      confirmTitle: 'Confirm Send',
      confirmMessage: 'Send broadcast email to {count} clients?'
    },
    // Messages
    messages: {
      success: 'Success',
      error: 'Error occurred',
      saved: 'Saved',
      deleted: 'Deleted',
      sent: 'Sent',
      cancelled: 'Cancelled',
      confirmDelete: 'Are you sure you want to delete?',
      fillAllFields: 'Please fill all required fields',
      emailRequired: 'Email is required',
      clientAdded: 'Client added and first ad sent successfully',
      keywordAdded: 'Keyword added',
      keywordDeleted: 'Keyword deleted',
      autoReplyEnabled: 'Auto-reply enabled'
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      loading: 'Loading...',
      noData: 'No data',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      of: 'of',
      yes: 'Yes',
      no: 'No',
      close: 'Close'
    },
    // WhatsApp
    whatsapp: {
      title: 'WhatsApp',
      settings: 'WhatsApp Settings',
      contacts: 'Contacts',
      keywords: 'Keywords',
      bulkMessages: 'Bulk Messages',
      messages: 'Message History',
      apiType: 'API Type',
      ultraMsgSettings: 'UltraMsg Settings',
      instanceId: 'Instance ID',
      token: 'Token',
      metaSettings: 'Meta Cloud API Settings',
      accessToken: 'Access Token',
      phoneNumberId: 'Phone Number ID',
      businessAccountId: 'Business Account ID',
      wahaSettings: 'WAHA Settings',
      apiUrl: 'API URL',
      sessionName: 'Session Name',
      apiKey: 'API Key',
      twilioSettings: 'Twilio Settings',
      accountSid: 'Account SID',
      authToken: 'Auth Token',
      whatsappNumber: 'WhatsApp Number',
      autoSendFirstAd: 'Auto-send first ad',
      testConnection: 'Test Connection',
      testPhone: 'Test Phone',
      delaySettings: 'Delay Settings (to avoid bans)',
      minDelay: 'Min delay (seconds)',
      maxDelay: 'Max delay (seconds)',
      pauseAfter: 'Pause after (messages)',
      pauseDuration: 'Pause duration (seconds)',
      adMessages: 'Ad Messages (8 messages)',
      adMessage: 'Ad Message',
      adDay: 'Send Day',
      attachment: 'Attachment',
      attachmentType: 'Attachment Type',
      uploadFile: 'Upload File',
      noAttachment: 'No attachment',
      image: 'Image',
      video: 'Video',
      document: 'Document',
      addContact: 'Add Contact',
      importCSV: 'Import CSV',
      exportContacts: 'Export Contacts',
      phone: 'Phone',
      name: 'Name',
      email: 'Email',
      source: 'Source',
      status: 'Status',
      adsSent: 'Ads Sent',
      hasReplied: 'Replied',
      active: 'Active',
      blocked: 'Blocked',
      invalid: 'Invalid',
      manual: 'Manual',
      fromEmail: 'From Email',
      csvImport: 'CSV Import',
      keywordTitle: 'WhatsApp Keywords',
      keywordSubtitle: 'Reply is sent automatically when keyword is detected',
      keyword: 'Keyword',
      response: 'Response',
      matchType: 'Match Type',
      contains: 'Contains',
      exact: 'Exact Match',
      startsWith: 'Starts With',
      priority: 'Priority',
      timesTriggered: 'Times Triggered',
      bulkTitle: 'Bulk Messages',
      createBulkJob: 'Create Bulk Job',
      jobName: 'Job Name',
      message: 'Message',
      selectContacts: 'Select Contacts',
      allContacts: 'All Contacts',
      selectSpecific: 'Select Specific',
      pasteNumbers: 'Paste Numbers',
      pasteNumbersPlaceholder: 'Paste numbers separated by commas...',
      startJob: 'Start Sending',
      pauseJob: 'Pause',
      resumeJob: 'Resume',
      cancelJob: 'Cancel',
      jobStatus: 'Status',
      progress: 'Progress',
      sent: 'Sent',
      failed: 'Failed',
      pending: 'Pending',
      running: 'Running',
      paused: 'Paused',
      completed: 'Completed',
      cancelled: 'Cancelled',
      sendMessage: 'Send Message',
      incoming: 'Incoming',
      outgoing: 'Outgoing',
      messageHistory: 'Message History',
      totalContacts: 'Total Contacts',
      activeContacts: 'Active Contacts',
      contactsWithReplies: 'With Replies',
      totalMessagesSent: 'Messages Sent',
      totalMessagesReceived: 'Messages Received',
      totalAdsSent: 'Ads Sent',
      totalKeywordReplies: 'Keyword Replies',
      activeKeywords: 'Active Keywords',
      runningJobs: 'Running Jobs',
      syncFromEmail: 'Sync from Email Leads',
      webhookSetup: 'Webhook Setup Required',
      webhookInfo: 'To receive incoming WhatsApp messages and auto-reply with keywords, configure this webhook URL in your WhatsApp API provider:',
      webhookInstructions: 'Copy this URL and paste it in your UltraMsg/Meta/WAHA webhook settings.',
      testKeyword: 'Test Keyword Matching',
      testPhone: 'Phone number (e.g. +96171910201)',
      testMessage: 'Test message with keyword',
      testButton: 'Test',
      bulkVariablesNote: 'Use these variables to personalize each message with client info'
    }
  },

  de: {
    // Login
    login: {
      title: 'Kontrollzentrum',
      subtitle: 'E-Mail-Automatisierungssystem',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      submit: 'Anmelden',
      loading: 'Anmeldung läuft...',
      error: 'Ungültige E-Mail oder Passwort',
      connectionError: 'Serververbindungsfehler',
      version: 'E-Mail-Automatisierungssystem v4.0'
    },
    // Dashboard
    dashboard: {
      title: 'E-Mail-Automatisierungssystem',
      version: 'Version 4.0',
      logout: 'Abmelden',
      language: 'Sprache'
    },
    // Stats
    stats: {
      totalClients: 'Gesamtkunden',
      subscribed: 'Abonniert',
      replied: 'Geantwortet',
      pendingEmails: 'Ausstehende E-Mails',
      sentEmails: 'Gesendete E-Mails'
    },
  // Tabs
  tabs: {
  settings: 'E-Mail-Einstellungen',
  multiLangAds: 'Mehrsprachige Anzeigen',
  adTemplates: 'Anzeigenvorlagen',
  keywords: 'Schlüsselwörter',
  leads: 'Kunden',
  scheduled: 'Geplant',
  replies: 'Antworten',
  broadcast: 'Rundmail',
  whatsapp: 'WhatsApp'
    },
    // System Status
    system: {
      title: 'Systemstatus',
      running: 'System läuft - E-Mails werden überwacht',
      stopped: 'System ist gestoppt',
      start: 'System starten',
      stop: 'System stoppen'
    },
    // Settings
    settings: {
      senderEmail: 'Absender-E-Mail (SMTP)',
      receiverEmail: 'Empfänger-E-Mail (IMAP)',
      senderName: 'Absendername',
      emailAddress: 'E-Mail-Adresse',
      appPassword: 'App-Passwort',
      host: 'Host',
      port: 'Port',
      welcomeEmail: 'Willkommens-E-Mail (Auto)',
      welcomeEmailDesc: 'Diese E-Mail wird automatisch an jeden neuen Kunden gesendet',
      enable: 'Aktivieren',
      subject: 'Betreff',
      body: 'Inhalt',
      saveSettings: 'Einstellungen speichern',
      saving: 'Speichern...'
    },
    // Ad Templates
    adTemplates: {
      title: 'Tägliche Anzeigenvorlagen',
      campaignDuration: 'Kampagnendauer',
      campaignDurationDesc: 'Anzahl der Tage für E-Mails an neue Kunden festlegen (nur eine E-Mail pro Tag)',
      duration: 'Dauer:',
      days: 'Tage',
      week: 'Woche',
      weeks: 'Wochen',
      month: 'Monat',
      months: 'Monate',
      templatesRepeat: 'Vorlagen wiederholen sich, wenn die Kampagne länger als 7 Tage dauert',
      day: 'Tag',
      active: 'Aktiv',
      saveTemplates: 'Vorlagen speichern',
      firstAdNote: 'Hinweis: Erste Anzeige wird sofort automatisch gesendet, wenn Kunde hinzugefügt wird',
      variablesHint: 'Verfügbare Variablen:',
      variableName: 'Kundenname',
      variablePhone: 'Kundentelefon',
      variableEmail: 'Kunden-E-Mail',
      variablesExample: 'Beispiel: Hallo {name}, wir haben ein Sonderangebot für Sie!'
    },
    // Keywords
    keywords: {
      title: 'Auto-Antwort Schlüsselwörter',
      subtitle: 'Antwort wird automatisch und sofort gesendet, wenn ein Schlüsselwort erkannt wird',
      keyword: 'Schlüsselwort',
      replySubject: 'Antwort-Betreff',
      replyTemplate: 'Antwort-Vorlage',
      add: 'Hinzufügen',
      noKeywords: 'Keine Schlüsselwörter',
      matches: 'Treffer',
      emailsSent: 'E-Mails gesendet',
      autoReplyNote: 'Auto-Antwort aktiviert - sendet sofort bei Erkennung des Schlüsselworts'
    },
    // Leads
    leads: {
      title: 'Kunden',
      search: 'Suchen...',
      addClient: 'Kunde hinzufügen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      status: 'Status',
      actions: 'Aktionen',
      subscribed: 'Abonniert',
      replied: 'Geantwortet',
      unsubscribed: 'Abgemeldet',
      extend: 'Verlängern',
      delete: 'Löschen',
      noClients: 'Keine Kunden'
    },
    // Add Lead Modal
    addLead: {
      title: 'Neuen Kunden hinzufügen',
      pasteMessage: 'Nachrichteninhalt hier einfügen (Umzugsdetails)',
      pasteMessagePlaceholder: 'Anfragenachricht hier einfügen...',
      extractedData: 'Extrahierte Daten (bearbeitbar):',
      clientName: 'Name',
      clientEmail: 'E-Mail *',
      clientPhone: 'Telefon',
      addNote: 'Beim Hinzufügen des Kunden:',
      addNoteWelcome: '1. Willkommens-E-Mail wird gesendet (wenn aktiviert)',
      addNoteFirstAd: '2. Erste Werbe-E-Mail wird sofort gesendet',
      addNoteSchedule: '3. Restliche Werbe-E-Mails werden geplant',
      addButton: 'Kunde hinzufügen & senden',
      adding: 'Hinzufügen...',
      cancel: 'Abbrechen'
    },
    // Scheduled Emails
    scheduled: {
      title: 'Geplante E-Mails',
      client: 'Kunde',
      subject: 'Betreff',
      scheduledFor: 'Geplant für',
      status: 'Status',
      actions: 'Aktionen',
      sendNow: 'Jetzt senden',
      cancel: 'Abbrechen',
      pending: 'Ausstehend',
      sent: 'Gesendet',
      failed: 'Fehlgeschlagen',
      cancelled: 'Abgebrochen',
      noScheduled: 'Keine geplanten E-Mails'
    },
    // Unknown Replies
    replies: {
      title: 'Unbekannte Antworten',
      from: 'Von',
      message: 'Nachricht',
      date: 'Datum',
      markRead: 'Als gelesen markieren',
      resolve: 'Lösen',
      noReplies: 'Keine Antworten'
    },
    // Broadcast
    broadcast: {
      title: 'Rundmail',
      description: 'Nachricht an alle abonnierten Kunden senden',
      subject: 'Betreff',
      body: 'Inhalt',
      attachment: 'Anhang (PDF, Bild, Video)',
      send: 'An alle senden',
      sending: 'Senden...',
      confirmTitle: 'Senden bestätigen',
      confirmMessage: 'Rundmail an {count} Kunden senden?'
    },
    // Messages
    messages: {
      success: 'Erfolg',
      error: 'Fehler aufgetreten',
      saved: 'Gespeichert',
      deleted: 'Gelöscht',
      sent: 'Gesendet',
      cancelled: 'Abgebrochen',
      confirmDelete: 'Sind Sie sicher, dass Sie löschen möchten?',
      fillAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
      emailRequired: 'E-Mail ist erforderlich',
      clientAdded: 'Kunde hinzugefügt und erste Anzeige erfolgreich gesendet',
      keywordAdded: 'Schlüsselwort hinzugefügt',
      keywordDeleted: 'Schlüsselwort gelöscht',
      autoReplyEnabled: 'Auto-Antwort aktiviert'
    },
    // Common
    common: {
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      add: 'Hinzufügen',
      search: 'Suchen',
      loading: 'Laden...',
      noData: 'Keine Daten',
      previous: 'Zurück',
      next: 'Weiter',
      page: 'Seite',
      of: 'von',
      yes: 'Ja',
      no: 'Nein',
      close: 'Schließen'
    },
    // WhatsApp
    whatsapp: {
      title: 'WhatsApp',
      settings: 'WhatsApp-Einstellungen',
      contacts: 'Kontakte',
      keywords: 'Schlüsselwörter',
      bulkMessages: 'Massennachrichten',
      messages: 'Nachrichtenverlauf',
      apiType: 'API-Typ',
      ultraMsgSettings: 'UltraMsg-Einstellungen',
      instanceId: 'Instanz-ID',
      token: 'Token',
      metaSettings: 'Meta Cloud API-Einstellungen',
      accessToken: 'Zugangstoken',
      phoneNumberId: 'Telefonnummer-ID',
      businessAccountId: 'Geschäftskonto-ID',
      wahaSettings: 'WAHA-Einstellungen',
      apiUrl: 'API-URL',
      sessionName: 'Sitzungsname',
      apiKey: 'API-Schlüssel',
      twilioSettings: 'Twilio-Einstellungen',
      accountSid: 'Konto-SID',
      authToken: 'Auth-Token',
      whatsappNumber: 'WhatsApp-Nummer',
      autoSendFirstAd: 'Erste Anzeige automatisch senden',
      testConnection: 'Verbindung testen',
      testPhone: 'Testnummer',
      delaySettings: 'Verzögerungseinstellungen (zur Vermeidung von Sperren)',
      minDelay: 'Min. Verzögerung (Sekunden)',
      maxDelay: 'Max. Verzögerung (Sekunden)',
      pauseAfter: 'Pause nach (Nachrichten)',
      pauseDuration: 'Pausendauer (Sekunden)',
      adMessages: 'Werbeanzeigen (8 Nachrichten)',
      adMessage: 'Werbeanzeige',
      adDay: 'Sendetag',
      attachment: 'Anhang',
      attachmentType: 'Anhangstyp',
      uploadFile: 'Datei hochladen',
      noAttachment: 'Kein Anhang',
      image: 'Bild',
      video: 'Video',
      document: 'Dokument',
      addContact: 'Kontakt hinzufügen',
      importCSV: 'CSV importieren',
      exportContacts: 'Kontakte exportieren',
      phone: 'Telefon',
      name: 'Name',
      email: 'E-Mail',
      source: 'Quelle',
      status: 'Status',
      adsSent: 'Gesendete Anzeigen',
      hasReplied: 'Geantwortet',
      active: 'Aktiv',
      blocked: 'Gesperrt',
      invalid: 'Ungültig',
      manual: 'Manuell',
      fromEmail: 'Von E-Mail',
      csvImport: 'CSV-Import',
      keywordTitle: 'WhatsApp-Schlüsselwörter',
      keywordSubtitle: 'Antwort wird automatisch gesendet, wenn Schlüsselwort erkannt wird',
      keyword: 'Schlüsselwort',
      response: 'Antwort',
      matchType: 'Übereinstimmungstyp',
      contains: 'Enthält',
      exact: 'Exakte Übereinstimmung',
      startsWith: 'Beginnt mit',
      priority: 'Priorität',
      timesTriggered: 'Mal ausgelöst',
      bulkTitle: 'Massennachrichten',
      createBulkJob: 'Massenjob erstellen',
      jobName: 'Jobname',
      message: 'Nachricht',
      selectContacts: 'Kontakte auswählen',
      allContacts: 'Alle Kontakte',
      selectSpecific: 'Spezifisch auswählen',
      pasteNumbers: 'Nummern einfügen',
      pasteNumbersPlaceholder: 'Nummern durch Kommas getrennt einfügen...',
      startJob: 'Senden starten',
      pauseJob: 'Pausieren',
      resumeJob: 'Fortsetzen',
      cancelJob: 'Abbrechen',
      jobStatus: 'Status',
      progress: 'Fortschritt',
      sent: 'Gesendet',
      failed: 'Fehlgeschlagen',
      pending: 'Ausstehend',
      running: 'Läuft',
      paused: 'Pausiert',
      completed: 'Abgeschlossen',
      cancelled: 'Abgebrochen',
      sendMessage: 'Nachricht senden',
      incoming: 'Eingehend',
      outgoing: 'Ausgehend',
      messageHistory: 'Nachrichtenverlauf',
      totalContacts: 'Gesamtkontakte',
      activeContacts: 'Aktive Kontakte',
      contactsWithReplies: 'Mit Antworten',
      totalMessagesSent: 'Gesendete Nachrichten',
      totalMessagesReceived: 'Empfangene Nachrichten',
      totalAdsSent: 'Gesendete Anzeigen',
      totalKeywordReplies: 'Schlüsselwort-Antworten',
      activeKeywords: 'Aktive Schlüsselwörter',
      runningJobs: 'Laufende Jobs',
      syncFromEmail: 'Von E-Mail-Leads synchronisieren',
      webhookSetup: 'Webhook-Einrichtung erforderlich',
      webhookInfo: 'Um eingehende WhatsApp-Nachrichten zu empfangen und automatisch mit Schlüsselwörtern zu antworten, konfigurieren Sie diese Webhook-URL in Ihrem WhatsApp-API-Anbieter:',
      webhookInstructions: 'Kopieren Sie diese URL und fügen Sie sie in Ihre UltraMsg/Meta/WAHA Webhook-Einstellungen ein.',
      testKeyword: 'Schlüsselwort-Matching testen',
      testPhone: 'Telefonnummer (z.B. +96171910201)',
      testMessage: 'Testnachricht mit Schlüsselwort',
      testButton: 'Testen',
      bulkVariablesNote: 'Verwenden Sie diese Variablen, um jede Nachricht mit Kundeninfos zu personalisieren'
    }
  }
  };

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value;
};

export const languages = [
  { code: 'ar', name: 'العربية', dir: 'rtl' },
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', dir: 'ltr' }
];
